// F.19: faktury, które nie trafiły do KSeF. Reguła „wymaga uwagi” żyje na serwerze
// (Login/backend/lib/ksefUwaga.js, GET /api/ksef-attention); tu tylko decyzje widoku. Teksty
// wybierają komponenty, żeby audyt tłumaczeń widział ich klucze.

export const MAKS_PRZYCZYNY_W_WIERSZU = 200;

/** Baner o fakturach: tylko gdy firma jest pilnowana i coś wymaga uwagi. */
export function pokazUwagi(dane) {
  return !!(dane && dane.aktywny && Number(dane.liczba) > 0);
}

/** Po terminie dosłania to błąd, reszta to ostrzeżenie. */
export function tonUwag(dane) {
  return dane && Number(dane.poTerminie) > 0 ? 'danger' : 'warning';
}

// Certyfikat albo token: baner od pierwszego progu przypomnień (serwer liczy poziom).
const POZIOMY_BANERU = ['uwaga', 'pilne', 'wygasl'];

export function pokazLogowanie(auth) {
  return !!(auth && POZIOMY_BANERU.includes(auth.poziom));
}

export function tonLogowania(auth) {
  return auth && (auth.poziom === 'wygasl' || auth.poziom === 'pilne') ? 'danger' : 'warning';
}

/** Przyczyna odmowy w wierszu listy: skrócona, pełna jest w szczegółach banera. */
export function skrocPrzyczyne(tekst, maks = MAKS_PRZYCZYNY_W_WIERSZU) {
  const t = String(tekst || '').trim();
  return t.length > maks ? `${t.slice(0, maks - 1).trimEnd()}…` : t;
}

const pad = (n) => String(n).padStart(2, '0');

/** Dzień kalendarzowy w strefie przeglądarki jako RRRR-MM-DD. */
export function dzienLokalny(data) {
  return `${data.getFullYear()}-${pad(data.getMonth() + 1)}-${pad(data.getDate())}`;
}

/**
 * Ważność zapisanego certyfikatu w Ustawieniach KSeF, te same progi co na serwerze
 * (lib/ksefTerminy.js): `uwaga` od 30 dni, `pilne` od 7, `wygasl` dzień po dniu końca.
 */
export function stanCertyfikatu(certValidTo, teraz = new Date()) {
  if (!certValidTo) return null;
  const koniec = new Date(certValidTo);
  if (Number.isNaN(koniec.getTime())) return null;
  const doDnia = Date.parse(`${dzienLokalny(koniec)}T00:00:00Z`);
  const dzis = Date.parse(`${dzienLokalny(teraz)}T00:00:00Z`);
  const dni = Math.round((doDnia - dzis) / 86400000);
  let poziom = 'ok';
  if (dni < 0) poziom = 'wygasl';
  else if (dni <= 7) poziom = 'pilne';
  else if (dni <= 30) poziom = 'uwaga';
  return { metoda: 'certificate', certDo: dzienLokalny(koniec), certDni: dni, poziom };
}
